import React from "react";

/**
 * Renders a gender icon as an SVG element.
 *
 * @param {Object} cls - The CSS class to be applied to the SVG element.
 * @return {JSX.Element} The SVG element representing the gender icon.
 */
export const TransGenderIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className={cls}
    >
      <g clipPath="url(#clip0_1824_57611)" className={cls}>
        <path
          d="M22 0.5H19C18.448 0.5 18 0.948 18 1.5C18 2.052 18.448 2.5 19 2.5H20.586L15.471 7.615C14.49 6.916 13.294 6.5 12 6.5C10.706 6.5 9.51 6.916 8.529 7.615L7.222 6.308L8.015 5.515C8.406 5.124 8.406 4.492 8.015 4.101C7.624 3.71 6.992 3.71 6.601 4.101L5.808 4.894L3.414 2.5H5C5.552 2.5 6 2.052 6 1.5C6 0.948 5.552 0.5 5 0.5H2C0.897 0.5 0 1.397 0 2.5V5.5C0 6.052 0.448 6.5 1 6.5C1.552 6.5 2 6.052 2 5.5V3.914L4.394 6.308L3.601 7.101C3.21 7.492 3.21 8.124 3.601 8.515C3.796 8.71 4.052 8.808 4.308 8.808C4.564 8.808 4.82 8.71 5.015 8.515L5.808 7.722L7.115 9.029C6.416 10.01 6 11.206 6 12.5C6 15.467 8.167 17.931 11 18.41V20.5H10C9.448 20.5 9 20.948 9 21.5C9 22.052 9.448 22.5 10 22.5H11V23.5C11 24.052 11.448 24.5 12 24.5C12.552 24.5 13 24.052 13 23.5V22.5H14C14.552 22.5 15 22.052 15 21.5C15 20.948 14.552 20.5 14 20.5H13V18.41C15.833 17.932 18 15.468 18 12.5C18 11.206 17.584 10.01 16.885 9.029L22 3.914V5.5C22 6.052 22.448 6.5 23 6.5C23.552 6.5 24 6.052 24 5.5V2.5C24 1.397 23.103 0.5 22 0.5ZM12 16.5C9.794 16.5 8 14.706 8 12.5C8 10.294 9.794 8.5 12 8.5C14.206 8.5 16 10.294 16 12.5C16 14.706 14.206 16.5 12 16.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1824_57611">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
